import { render, staticRenderFns } from "./BaseSelectFooter.vue?vue&type=template&id=d1cb0100&"
import script from "./BaseSelectFooter.vue?vue&type=script&lang=ts&"
export * from "./BaseSelectFooter.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSelectFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports